import {
  getUserRef,
  getUserEmail,
  getUserFirstName,
  getUserLastName,
} from './session';
import type { User } from '../types';

export function getCurrentUser(): User | undefined {
  const id = getUserRef();
  if (!id) return undefined;
  const name = `${getUserFirstName()} ${getUserLastName()}`.trim();
  return {
    id,
    name,
    email: getUserEmail(),
  };
}

export function signOut() {
  sessionStorage.clear();
}
